export enum EventSelectModal {
  EventSelector = 'JqF5',
  SelectEventTitle = 'rGNb',
  EventName = 'YdUX',
  EventDate = 'CQFr',
  SelectEventTitleLowerCase = 'otMv',
}
